import moment from 'moment'
import React, { useEffect, useState } from 'react'

export const UserCard = () => {
    const [data, setData] = useState()
    const [changeUser, setChangeUser] = useState(0)

    useEffect(() => {
        const fetchData = async () => {
            const response = await fetch('https://randomuser.me/api')
                .then(res => res.json())
                .then(data => data.results[0])
                .catch(error => console.log(error))
            setData(response)
        }
        fetchData()
    }, [changeUser])

    return (
        <section className='bg-[#0d1520] rounded-2xl p-4 sm:p-8 m-2 overflow-hidden shadow-2xl transition-all duration-1000 ease-in-out'>
            <header className='text-3xl text-center pb-8'>
                Profile Card
            </header>
            <section className='flex flex-col sm:flex-row gap-10 '>
                <div className='flex flex-col items-center'>
                    <img src={data?.picture?.large} alt="profilePic" className='w-28  object-cover rounded-full' />
                    <h1 className='font-bold text-lg pt-3'>{data?.name?.first + " " + data?.name?.last}</h1>
                    <p className='text-sm opacity-60 '>{data?.location?.state + ", " + data?.location?.country}</p>
                </div>
                <div className='text-xl flex flex-col'>
                    <div className='grid grid-cols-3 gap-5 opacity-60 text-sm'>
                        <p>Gender</p>
                        <p>Date of birth</p>
                        <p>Username</p>
                    </div>
                    <div className='grid grid-cols-3 gap-5 text-sm sm:text-lg'>
                        <p>{data?.gender.toUpperCase()}</p>
                        <p>{moment(data?.dob?.date).format('MMM DD, YYYY')}</p>
                        <p>@{data?.login?.username}</p>
                    </div>
                    <a href="mailto:" className='my-3 text-center opacity-60 underline'>{data?.email}</a>
                    <div className='w-full mt-auto text-right'>
                        <button className='w-fit px-4 py-2 bg-[#373d45] rounded-xl text-lg hover:scale-110 transition-all duration-500 ease-in-out' onClick={() => setChangeUser(prev => prev + 1)}>Surprise Me</button>
                    </div>
                </div>
            </section>
        </section>

    )
}
